import PopupOptions from "../../popup_select_component/PopupOptions";
import LinkForPopupPropTypes from "../../LinkForPopupPropTypes";
import PropTypes from "prop-types";
import React from "react";

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'react-app-polyfill/ie11';

const LinkForPopup = (props) => {
  return (
    <a className="inline_link recruitment_ordering" onClick={props.onClickPopupLink}>
      <input
        type="text"
        name="input_recruitment_ordering_name"
        className="recruitment_ordering no_icon"
        placeholder="詳細条件を選択"
        readOnly="readonly"
        value={props.inputValue}
        onChange={props.onChangeInputValue}
      />
    </a>
  );
};

LinkForPopup.propTypes = LinkForPopupPropTypes;

export default LinkForPopup;
